/**
 * 种植方案的模板，作为初始值
 */
export default {
  id: undefined,
  name: '',
  varietyId: undefined,
  varietyName: undefined,
  memo: '',
  /**
   * 方案总时长（天数）
   */
  duration: 2,
  /**
   * 阶段数，字段原名totalStageCount
   */
  phaseCount: 2,
  /**
   * 阶段详细，字段原名plantSchemeDetailEntityLists
   */
  phases: [{
      /**
       * 阶段名称，字段原名stageName
       */
      name: '栽种定植',
      /**
       * 阶段次序（在所有阶段中的位次，从1开始），字段原名stage
       */
      index: 1,
      /**
       * 阶段附加标识。字段原名identification
       */
      badge: 'plant', //种植期特殊标识
      /**
       * 这是什么含义？
       */
      // stageDay: 1,
      /**
       * 本阶段时长（天数）
       */
      dutation: 1,
      /**
       * 建议和备忘
       */
      suggest: [],
      /**
       * 种植方案的某阶段的说明介绍
       */
      memo: undefined,
      /**
       * 本阶段环境控制参数。如果某个阶段无需环境控制，则此字段值为{}
       */
      environs: {
        airt: [15, 25], //空气温度
        airh: [30, 50], //空气湿度
        illu: [3, 6], //光照强度
        co2: [200, 600], //二氧化碳
        soilt: [18, 28], //土壤温度度
        soilh: [30, 50], //土壤湿度
        adh: [500, 800], //积温
        par: [2000, 5000], //光合辐照
      },
      switchValue: false //参数开关
    },
    {
      name: '采摘',
      index: 2,
      badge: 'harvest', //收获期阶段特殊标识
      // stageDay: 1,
      suggest: [],
      dutation: 1,
      environs: {
        airt: [15, 25], //空气温度
        airh: [30, 50], //空气湿度
        illu: [3, 6], //光照强度
        co2: [200, 600], //二氧化碳
        soilt: [18, 28], //土壤温度度
        soilh: [30, 50], //土壤湿度
        adh: [500, 800], //积温
        par: [2000, 5000],
      },
      switchValue: false //参数开关
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/plant/programme/scheme-default.js